package fr.frux.feature.site.detail

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import fr.frux.core.designsystem.components.FruxButton
import fr.frux.core.designsystem.components.FruxButtonStyle
import fr.frux.core.designsystem.theme.FruxSpacing
import fr.frux.feature.site.resources.Res
import fr.frux.feature.site.resources.site_private_locked_notified
import fr.frux.feature.site.resources.site_private_locked_notify
import fr.frux.feature.site.resources.site_private_locked_text
import org.jetbrains.compose.resources.stringResource

private val NOTIFIED = Res.string.site_private_locked_notified
private val NOTIFY = Res.string.site_private_locked_notify

/** Lieu privé sans récolte annoncée (maquette FichePrive) : verrouillé, on ne peut que se faire prévenir. */
@Composable
internal fun SitePrivateNotice(
    isFavorite: Boolean,
    onFavorite: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Surface(
        shape = MaterialTheme.shapes.medium,
        color = MaterialTheme.colorScheme.surfaceVariant,
        modifier = modifier.fillMaxWidth(),
    ) {
        Column(
            modifier = Modifier.padding(FruxSpacing.md),
            verticalArrangement = Arrangement.spacedBy(FruxSpacing.sm),
        ) {
            Text(
                text = stringResource(Res.string.site_private_locked_text),
                style = MaterialTheme.typography.bodyMedium,
            )
            FruxButton(
                text = stringResource(if (isFavorite) NOTIFIED else NOTIFY),
                onClick = onFavorite,
                style = if (isFavorite) FruxButtonStyle.Tonal else FruxButtonStyle.Filled,
            )
        }
    }
}
